const PREFIX = 'RSS'

export const GET_RSS_PODCASTS = `GET_${PREFIX}_PODCASTS`
export const CLEAR_RSS_PODCASTS = `CLEAR_${PREFIX}_PODCASTS`
export const RSS_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const SET_RSS_PODCAST = `SET_${PREFIX}_PODCAST`
export const CLEAR_RSS_PODCAST = `CLEAR_${PREFIX}_PODCAST`
export const SET_RSS_PLAYLIST = `SET_${PREFIX}_PLAYLIST`
export const CLEAR_RSS_PLAYLIST = `CLEAR_${PREFIX}_PLAYLIST`
export const RSS_PLAY_STATUS = `${PREFIX}_PLAY_STATUS`